import { Outlet, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '@/hooks/useAuth';

export default function AuthLayout() {
  const { isAuthenticated, isAdmin } = useAuth();
  if (isAuthenticated) return <Navigate to={isAdmin ? '/admin' : '/dashboard'} replace />;

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-slate-50 dark:bg-slate-950">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-gradient-to-br from-brand-700 via-brand-600 to-indigo-700 text-white relative overflow-hidden">
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-white/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-indigo-400/20 rounded-full blur-3xl" />
        <div className="relative">
          <img
            src="/logo.svg"
            alt="Employee Desk CRM"
            className="h-32 sm:h-40 w-auto max-w-full object-contain drop-shadow-2xl"
          />
          <div className="text-sm font-medium text-white/80 mt-3">
            Employee Attendance & Work Tracking
          </div>
          <motion.h1
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl font-bold leading-tight max-w-md mt-5"
          >
            One workspace for your team's attendance, projects and daily work.
          </motion.h1>
          <p className="mt-4 text-white/80 max-w-md">
            Track check-ins, manage leaves, monitor tasks and get clear reports — built for modern software teams.
          </p>
        </div>
        <div className="relative text-white/60 text-sm">© {new Date().getFullYear()} Employee Desk CRM. All rights reserved.</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="w-full max-w-md"
        >
          <Outlet />
        </motion.div>
      </div>
    </div>
  );
}
